import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Cross from '../../../../webcommon/common/Icons/Cross.svg';
import { noop } from 'lodash';
import ActionButton from '../../../../webcommon/common/actionbutton/ActionButton';
import Checkbox from '../../../../webcommon/common/checkbox/Checkbox';
import defaultStyles from './CreateLoadRequest.module.scss';
import CustomDropdown from './CustomDropdown';
import CustomDatePicker from './CustomDatePicker';

const CreateLoadRequest = (props) => {
    const {
        loadRequestMappings,
        createLoadRequest,
        closeModal
    } = props;

    const [sourceType, setSourceType] = useState('');
    const [category, setCategory] = useState('');
    const [date, setDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [dateFocused, setDateFocused] = useState(false);
    const [endDateFocused, setEndDateFocused] = useState(false);
    const [usingDateRange, setUsingDateRange] = useState(false);
    // const [unsegMode, setUnsegMode] = useState(false);

    const findAvailableOptions = useCallback((key, source) => (loadRequestMappings.find(
        mapping => mapping.dataSource === source
    ) ? loadRequestMappings.find(
            mapping => mapping.dataSource === source
        )[key] : []), [loadRequestMappings]);

    const setSourceTypeMemoized = useCallback((source) => {
        setSourceType(source);
        if (category !== '' && !findAvailableOptions('categories', source).includes(category)) {
            setCategory('');
        }
        const availableCategories = findAvailableOptions('categories', source);
        if (availableCategories && availableCategories.length === 1) {
            setCategory(availableCategories[0]);
        }
    },
    [setSourceType, category, findAvailableOptions]);

    const setCategoryMemoized = useCallback((categ) => {
        setCategory(categ);
    },
    [setCategory]);

    const setDateRangeMemoized = useCallback((useDateRange) => {
        setUsingDateRange(useDateRange);
    },
    [setUsingDateRange]);
    // const setUnsegModeMemoized = useCallback((unseg) => {
    //     setUnsegMode(unseg);
    // },
    // [setUnsegMode]);

    const createLoadRequestMemoized = useCallback(() => {
        createLoadRequest(
            sourceType, category, date, endDate/*, unsegMode*/);
        closeModal();
    },
    [sourceType, category, date, createLoadRequest, endDate/*, unsegMode*/, closeModal]);

    return (
        <div className={ props.styles.loadRequestWrapper }>
            <div className={ props.styles.loadRequestHeader }>
                Create new load request
                <button
                    type="button"
                    className={ props.styles.requestHeaderCloseButton }
                    onClick={ props.closeModal }
                >
                    <img
                        alt="Cross"
                        src={ Cross }
                        className={ props.styles.svg }
                    />
                </button>
            </div>

            <div className={ props.styles.rowOneFilters }>
                <div className={ props.styles.sourceTypeFilter }>
                    <CustomDropdown
                        activeValue={ sourceType }
                        options={ props.loadRequestMappings.map(mapping => mapping.dataSource) }
                        setActiveValue={ setSourceTypeMemoized }
                        title="Source Type"
                    />
                </div>
                <div className={ props.styles.categoryFilter }>
                    <CustomDropdown
                        activeValue={ category }
                        options={ findAvailableOptions('categories', sourceType) }
                        setActiveValue={ setCategoryMemoized }
                        title="Category"
                    />
                </div>
            </div>

            <div className={ props.styles.rowTwoFilters }>
                {/* <stackpanel className={props.styles.unseg}>
                    <label className={ props.styles.unsegCheckboxText }>
                           {unsegMode ? 'UnsegMode' : 'Seg-Mode  '}
                    </label>
                    <div className={ props.styles.unsegCheckbox }>
                        <Checkbox
                        checked={ unsegMode }
                        onChange={ setUnsegModeMemoized }
                        />
                    </div>
                </stackpanel> */}
                <div className={ props.styles.dateFilter }>
                    <CustomDatePicker
                        date={ date }
                        dateFocused={ dateFocused }
                        setDate={ setDate }
                        setDateFocused={ setDateFocused }
                        title={ usingDateRange ? 'Start Date' : 'Run Date' }
                    />
                </div>
                <div className={ props.styles.dateFilter }>
                    {usingDateRange
                    && (
                        <CustomDatePicker
                            date={ endDate }
                            dateFocused={ endDateFocused }
                            setDate={ setEndDate }
                            setDateFocused={ setEndDateFocused }
                            title={ usingDateRange ? 'End Date' : '' }
                        />
                    ) }
                </div>
                
            </div>

            <div className={ props.styles.rowThreeFilters }>
                <div className={ props.styles.loadRequestButtons }>
                    <div className={ props.styles.loadRequestCreateButton }>
                        <ActionButton
                            accent
                            onClick={ createLoadRequestMemoized }
                        >
                            Create
                        </ActionButton>
                    </div>
                    <div className={ props.styles.loadRequestCancelButton }>
                        <ActionButton
                            onClick={ props.closeModal }
                        >
                            Close
                        </ActionButton>
                    </div>
                    <div className={ props.styles.dateRangeWrapper }>
                        <div className={ props.styles.dateRangeText }>
                            Select Date Range
                        </div>
                        <div className={ props.styles.selectDateRangeCheckbox }>
                            <Checkbox
                                checked={ usingDateRange }
                                onChange={ setDateRangeMemoized }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

CreateLoadRequest.propTypes = {
    closeModal: PropTypes.func,
    createLoadRequest: PropTypes.func,
    loadRequestMappings: PropTypes.arrayOf(PropTypes.shape({})),
    styles: PropTypes.objectOf(PropTypes.string)
};

CreateLoadRequest.defaultProps = {
    closeModal: noop,
    createLoadRequest: noop,
    loadRequestMappings: [],
    styles: defaultStyles
};

export default CreateLoadRequest;
